import Image from 'next/future/image';

const FaqsBanner = (props: any) => {
  const faqData = props?.faqBannerData?.attributes?.Section;
  return (
    <div className="container-xl custom-container px-0">
      <section className="hero-section">
        <div className="hero-banner FAQ-banner">
          <Image
            sizes="(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1280px"
            src={faqData[0]?.Background_Image?.data.attributes?.url}
            alt={
              faqData[0]?.Background_Image?.data.attributes?.alternativeText ||
              faqData[0]?.Background_Image?.data.attributes?.name
            }
            className="banner-img"
            width="1280"
            height="516"
          />
          <div className="banner-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 m-auto">
                  <h1>{faqData[0]?.Title}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="promotion-banner">
          <p>{faqData[1]?.Title}</p>
        </div>
      </section>
    </div>
  );
};

export default FaqsBanner;
